import axios from "../axios";

export const downloadMonthlyReport = async (year, month) => {
  return axios.get(
    `/api/Task/MonthlyReport?Year=${year}&Month=${month}`,
    {
      responseType: "blob",
    }
  );
};